<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6" md="12">
        <b-card>
          <div slot="header">
            <strong>Degree Verification</strong>
          </div>
          <b-row>
            <b-col>
              <b-form-group
                label="Identification No./Passport No. :"
                label-for="CITIZENID"
                :label-cols="3"
                :horizontal="true"
                :invalid-feedback="citizenIDInvalid"
                :valid-feedback="citizenIDValid"
              >
                <b-form-input
                  id="CITIZENID"
                  type="text"
                  name="CITIZENID"
                  v-model="getdata.CITIZENID"
                  :state="citizenIDState"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Student Identification Number :"
                label-for="STUDENTID"
                :label-cols="3"
                :horizontal="true"
                :invalid-feedback="studentIDInvalid"
                :valid-feedback="studentIDValid"
              >
                <b-form-input
                  id="STUDENTID"
                  type="number"
                  name="STUDENTID"
                  v-model="getdata.STUDENTID"
                  :state="studentIDState"
                ></b-form-input>
              </b-form-group>

              <div slot="footer">
                <b-button size="md" variant="success" class="btn-md" @click="searchData">
                  <i class="fa fa-search"></i> Search
                </b-button>

                <hr />
                <b-alert show variant="success" v-if="chkalert===1">Successfully searched for information.</b-alert>
                <b-alert show variant="danger" v-if="chkalert===2">Data not found.</b-alert>
                <b-alert show variant="warning" v-if="chkalert===3">Just a moment please...</b-alert>

                <b-modal
                  title="Please complete the information."
                  class="modal-danger"
                  v-model="dangerModal"
                  @ok="dangerModal = false"
                  ok-variant="danger"
                >
                  <div v-if="errors.length">
                    <ul>
                      <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                  </div>
                </b-modal>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col lg="6" md="12">
        <b-card>
          <div slot="header">
            <strong>Organization Details</strong>
          </div>
          <b-row>
            <b-col>
              <p>
                <label>
                  <b>Organization :</b>
                  {{companydata.COMPANY_NAME}}
                </label>
              </p>
              <p>
                <label>
                  <b>Name-Surname :</b>
                  {{companydata.USER_NAME}} {{companydata.USER_SURNAME}}
                </label>
              </p>
              <p>
                <label>
                  <b>Telephone :</b>
                  {{companydata.MOBILE}}
                </label>
              </p>
              <p>
                <label>
                  <b>E-Mail :</b>
                  {{companydata.EMAIL}}
                </label>
              </p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="items.length">
      <b-col lg="12" md="12">
        <b-card>
          <div slot="header">
            <strong>Detail</strong>
          </div>
          <b-row>
            <b-col>
              <b-table
                bordered
                hover
                responsive
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                :mobile-cards="hasMobileCards"
              >

                    <template #cell(DEGREECERTIFICATE)="data">
                      <span v-html="data.value"></span>
                    </template>

                    <template #cell(TOOL)="data">
                      <button
                        class="btn btn-md btn-success btn-block"
                        @click="searchPdf(data.item.TOOL,data.item.STUDENTCODE)"
                      >DOWNLOAD</button>
                    </template>

              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AuthenService from "@/services/AuthenService";
import VerificationService from "@/services/VerificationService";
import store from "@/store/store";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  name: "Login",
  data: () => ({
    getdata: {
      STUDENTID: "", //5031305332
      CITIZENID: "", //1520900034819
      USERID: 0
    },
    companydata: [],
    errors: [],
    dangerModal: false,
    chkalert: 0,
    chkerror: 1,
    items: [
    ],
    fields: [
      {
        key: "STUDENTCODE",
        label: "Student Code"
      },
      {
        key: "STUDENTNAME",
        label: "Name-Surname"
      },
      {
        key: "DEGREECERTIFICATE",
        label: "Degree"
      },
      {
        key: "GRADUATEDATE",
        label: "Date of Graduation"
      },
      {
        key: "HORNOR",
        label: "Honors"
      },
      {
        key: "TOOL",
        label: "Form"
      }
    ],
    url: [],
    perPage: 100,
    currentPage: 1,
    hasMobileCards: true
  }),
  mounted: function() {
    this.chktoken();
  },
  computed: {
    studentIDState() {
      return this.getdata.STUDENTID.length > 9 &&
        this.getdata.STUDENTID.length < 11
        ? true
        : false;
    },
    studentIDInvalid() {
      if (this.studentIDState) {
        return "";
      } else {
        return "Please fill in the correct information.";
      }
    },
    studentIDValid() {
      return this.studentIDState === true ? "Thank you" : "";
    },
    citizenIDState() {
      return this.getdata.CITIZENID.length > 1 ? true : false;
    },
    citizenIDInvalid() {
      if (this.citizenIDState) {
        return "";
      } else {
        return "Please fill in the correct information.";
      }
    },
    citizenIDValid() {
      return this.citizenIDState === true ? "Thank you" : "";
    }
  },
  methods: {
    async chktoken() {
      //console.log(this.$route.params);
      //*********************************** */
      let params = this.$route.params;
      //let url = "?userid=" + params.userid + "&emailtoken=" + params.token;
      let url = {
        userid : params.userid,
        emailtoken : params.token
      }
      //console.log(url);
      this.getdata.USERID = params.userid;
      //*********************************** */
      const data = await VerificationService.getApiChkToken(url);
      //*********************************** */
      if (data === 404) {
        this.$router.push("/pages/login");
      } else if (data === 500) {
        this.$router.push("/pages/login");
      } else {
        this.companydata = data.data;
        //console.log(data);
      }
    },
    async searchData(e) {
      this.errors = [];

      if (this.getdata.STUDENTID && this.getdata.CITIZENID) {
        this.dangerModal = false;
        //********************************************************* */
        await this.sendData(this.getdata);
        //********************************************************* */
        this.getdata.STUDENTID = "";
        this.getdata.CITIZENID = "";
        //********************************************************* */
      } else {
        if (!this.getdata.STUDENTID) this.errors.push("Please specify student ID.");
        if (!this.getdata.CITIZENID)
          this.errors.push("Please specify ID / Passport code.");

        e.preventDefault();

        this.dangerModal = true;
      }
    },
    async sendData(e) {
      this.chkalert = 3;
      let url =
        "?sid=" +
        e.STUDENTID +
        "&cid=" +
        e.CITIZENID +
        "&lang=en" +
        "&uid=" +
        e.USERID;
      const data = await VerificationService.getApiChkStudentID(url);
      if (data == 400) {
        this.chkalert = 2;
      } else {
        var setTextDegree = "";
        //-------------------------------------------------------------
        if(data.data[0].STUDENTSTATUS === 40 || data.data[0].STUDENTSTATUS === 42){
          setTextDegree = data.data[0].DEGREECERTIFICATE;
        }
        else{
          setTextDegree = '<span class="text-danger">' + data.data[0].STUDENTSTATUSDES + '</span>';
        }
        //-------------------------------------------------------------
        this.items.push({
          STUDENTCODE: data.data[0].STUDENTCODE,
          STUDENTNAME:
            data.data[0].PREFIXNAME +
            " " +
            data.data[0].STUDENTNAME +
            " " +
            data.data[0].STUDENTSURNAME,
          DEGREECERTIFICATE: setTextDegree,
          GRADUATEDATE: data.data[0].GRADUATEDATETEXT,
          HORNOR: data.data[0].HORNORTEXT,
          STUDENTSTATUS: data.data[0].STUDENTSTATUS,
          STUDENTSTATUSDES: data.data[0].STUDENTSTATUSDES,
          TOOL: data.pdf.data
        });
        this.chkalert = 1;
      }
    },
    searchPdf(pdf, stucode) {
      //
      const linkSource = "data:application/pdf;base64," + pdf;
      const downloadLink = document.createElement("a");
      const fileName = "mfu-qualification-" + stucode + ".pdf";
      //************************************************ */
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
      //************************************************ */
    },
    frontFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    }
  }
};
</script>

<style>
.btn-login {
  color: #ffffff;
  background-color: #8c1515;
  border-color: #8c1515;
  margin-bottom: 10px;
}

.wapper_detail_login {
  background-color: #8c1515;
  border: 1px #a07517 solid;
  border-radius: 0px 0px 0px 0px;
}

.wapper_detail_login_footer {
  background-color: #8c1515;
  border: 1px #a07517 solid;
  border-radius: 0px 0px 0px 0px;
}

.copyright {
  font-size: x-small;
  position: absolute;
  bottom: 0px;
  width: 100%;
  left: 0;
}
</style>
